/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const validationWorkflowCreateRequestNameMax = 256;

export const validationWorkflowCreateRequestDescriptionMax = 1024;

export const ValidationWorkflowCreateRequest = zod.strictObject({
    name: zod.string().min(1).max(validationWorkflowCreateRequestNameMax),
    description: zod
        .string()
        .max(validationWorkflowCreateRequestDescriptionMax)
        .optional(),
    forms: zod.array(zod.number()).optional(),
});

export type ValidationWorkflowCreateRequest = zod.input<
    typeof ValidationWorkflowCreateRequest
>;
export type ValidationWorkflowCreateRequestOutput = zod.output<
    typeof ValidationWorkflowCreateRequest
>;
